import { useContext } from 'react';
import { MediaUploadType } from '../../modules/assets/types';
import { EntryValueType } from '../../modules/entries/types';
import { TableStoreContext } from '../../stores/TableStoreContext';
import { CellLocation } from '../../stores/types';
import { CellSchema, CellStateEnum, ReferenceOptionsData } from '../types';

export const useCellState = (cellLocation: CellLocation) => {
  const tableStore = useContext(TableStoreContext);

  const getCellSchema = (): CellSchema => {
    const fieldNames = tableStore.table?.keyOrder?.length ? tableStore.table?.keyOrder : Object.keys(tableStore.table?.schema || {});
    const fieldName = fieldNames[cellLocation.column];
    return {
      fieldName,
      fieldSchema: tableStore.table?.schema[fieldName],
    };
  };

  const getReferenceOptionsData = (): ReferenceOptionsData => {
    return {
      referenceFieldNames: tableStore.referenceFieldNames,
    };
  };

  const updateCellState = (newCellState: CellStateEnum) => {
    tableStore.updateCellState(newCellState, cellLocation);
  };

  const updateCellValue = async (
    databaseSlug: string,
    tableSlug: string,
    cellValue: EntryValueType,
  ) => {
    await tableStore.updateCellValue(databaseSlug, tableSlug, cellValue, cellLocation);
  };

  const uploadAsset = async (
    databaseSlug: string,
    tableSlug: string,
    file: File, 
    assetType: MediaUploadType,
  ) => {
    await tableStore.uploadAsset(databaseSlug, tableSlug, file, cellLocation, assetType);
  };

  return {
    getCellSchema,
    getReferenceOptionsData,
    updateCellState,
    updateCellValue,
    uploadAsset,
  };
};
